import Instance from '../../../Axios';

const AdicionarParceiros = (ydata) => async (dispatch) => {
  console.log(ydata);
  await Instance()
    .post('/backend/parceiros/', { ydata })
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'POST_PARCEIROS', payload: data });
      //   show('success', 'Foram associados novos funcionários á obra');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
      }
    });
};

export default AdicionarParceiros;
